module.exports = __webpack_public_path__ + "img/4.47e714f8.png";